import { watchersConstants } from "../../_constants";


const initialState = {};

//all jobs reducer
export const get_all_watcher_jobs_reducer = (
    state = initialState,
    action
  ) => {
    switch (action.type) {
      case watchersConstants.GET_JOB_WATCHER_ACTION_REQUEST:
        return {
          type: "alert-success",
          message: action.payload,
        };
      case watchersConstants.GET_JOB_WATCHER_ACTION_SUCCESS:
        return {
          type: "alert-success",
          allWatchersJobsData: action.payload,
        };
      case watchersConstants.GET_JOB_WATCHER_ACTION_FAILURE:
        return {
          type: "alert-failure",
          message: action.payload,
        };
      default:
        return state;
    }
  };

